import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const VerifyInstantPayment = ({
  loading,
  onSubmit,
  closeModal,
  statusData,
  validationSchema,
  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <div style={{ width: "38rem" }}>
        <MimaText variant="subtitleBold" align="center" mb="7">
          Verify Express Exchange Payment by {singleItem.buyer.username}
        </MimaText>
        <MimaText mb={2} labelTitle="Confirm Buyer Paid">
          {amountFormatter(singleItem.buyerDebitValue.currencyCode).format(
            singleItem?.buyerDebitValue.amount
          )}
        </MimaText>
        <MimaText mb={2} labelTitle="Confirm Reference Code">
          {singleItem?.referenceCode}
        </MimaText>
        <Formik
          initialValues={{
            amount: "",
            buyerStatus: "",
            note: "",
            buyerPaymentDateTime: "",
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <div>
              <MimaInput
                name="amount"
                labelTitle="Enter Amount Buyer Paid"
                placeholder="Enter Amount Buyer Paid"
                type="number"
                value={values.amount}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.amount}
                touched={touched.amount}
              />
              <MimaDropdown
                labelTitle="Status"
                placeholder="Select status"
                name="buyerStatus"
                data={statusData}
                value={values.buyerStatus}
                id="buyerStatus"
                onChange={(data) => {
                  setFieldValue("buyerStatus", data.key);
                }}
                error={errors.buyerStatus}
                touched={touched.buyerStatus}
              />

              <MimaDateInput
                labelTitle="Date and Time Transaction was received"
                name="buyerPaymentDateTime"
                value={values.buyerPaymentDateTime}
                onChange={(text) => {
                  setFieldValue("buyerPaymentDateTime", text);
                }}
                onBlur={handleBlur}
                touched={touched.buyerPaymentDateTime}
                error={errors.buyerPaymentDateTime}
                showTimeSelect
              />

              <MimaTextArea
                labelTitle="Note"
                variant="message"
                placeholder="Enter Note"
                name="note"
                value={values.note}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.note}
                touched={touched.note}
                mb={2}
              />
              <MimaButton
                title="Continue"
                width={38}
                onClick={handleSubmit}
                loading={loading}
              />
            </div>
          )}
        </Formik>
      </div>
    </Modal>
  );
};
export default VerifyInstantPayment;
